import React from "react";
import ArrowUpwardOutlined from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlined from "@mui/icons-material/ArrowDownwardOutlined";

export default function SortableHeader({
  label,
  sortOrder,
  columnName,
  onClick,
  sorting,
}) {
  const isSorted = sortOrder?.name === columnName;

  return (
    <th
      style={{
        fontSize: "10px",
        padding: "8px",
        cursor: sorting ? "pointer" : "default", // ubah cursor juga biar UX lebih bagus
        border: "1px solid #ddd",
        backgroundColor: "#f9f9f9",
        textAlign: "left",
      }}
      onClick={sorting ? onClick : undefined}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span>{label}</span>
        {sorting && (
          <div style={{ display: "flex", alignItems: "center" }}>
            {isSorted && sortOrder.direction === "asc" && (
              <ArrowUpwardOutlined style={{ fontSize: 16 }} />
            )}
            {isSorted && sortOrder.direction === "desc" && (
              <ArrowDownwardOutlined style={{ fontSize: 16 }} />
            )}
          </div>
        )}
      </div>
    </th>
  );
}
